import { Typography } from "@circle-react-shared/uikit/Typography";

interface SubtitleProps {
  prefix?: string;
  subtitle: string;
}

export const Subtitle = ({ prefix, subtitle }: SubtitleProps) => (
  <span className="flex flex-row">
    {prefix && (
      <Typography.LabelXs color="text-default" weight="normal">
        <span className="pr-1 align-text-bottom line-through">{prefix}</span>
      </Typography.LabelXs>
    )}
    <Typography.LabelXs color="text-default" weight="medium">
      <span className="inline-block whitespace-nowrap">{subtitle}</span>
    </Typography.LabelXs>
  </span>
);
